import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        textAlign: "center",
      }}
    >
      <Typography variant="h3" component="h1">
        404
      </Typography>
      <Typography>お探しのページは見つかりませんでした。</Typography>
      <Button component={Link} to="/" variant="contained">
        トップページへ戻る
      </Button>
    </Box>
  );
}

export default NotFound;
